/** Full calendar dates use day/month/year regardless of browser language. */
export const VI_DATE_DISPLAY_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
};

export const VI_DATETIME_DISPLAY_OPTIONS: Intl.DateTimeFormatOptions = {
  ...VI_DATE_DISPLAY_OPTIONS,
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false
};
